export default __webpack_public_path__ + "static/media/clock-icon.fe88aef5.svg";